import React from "react";
import GooglePlayStore from "./assets/google-play-button.png";
import AppStore from "./assets/app-store-button.png";
import { GotAQuestion } from "./components/GotAQuestion";

export const pageType: "casual" | "expert" = "casual"

export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

let screenSize: { width: number; height: number } = { width: -1, height: -1 };
let isMobile = false;
let isTablet = false;

export function adjustFontSizeForScreenWidth(size: number): string {
  if (isMobile) {
    return (size * (Math.min(350, screenSize.width) / 350)).toFixed(0) + "px"
  }
  if (isTablet) {
    return (size * (Math.min(1100, screenSize.width) / 1100)).toFixed(0) + "px"
  }
  return (size * (Math.min(1600, screenSize.width) / 1600)).toFixed(0) + "px"
}

export const maxWidthNormalContent: string = "1900px"

export const appStoreLink = "https://testflight.apple.com/join/9yC3fSQs";
export const googlePlayLink = "https://play.google.com/store/apps/details?id=com.parallelpoker.texasholdem";
export const linkTree = "https://linktr.ee/parallelpoker"

export function isIOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

export function getMobileDownloadLink() {
  if (isIOS()) {
    return appStoreLink;
  } else if (isAndroid()) {
    return googlePlayLink;
  }
  return null;
}

export function getMobileDownloadButtonValues() {
  if (isIOS()) {
    return { source: AppStore, link: appStoreLink };
  } else if (isAndroid()) {
    return { source: GooglePlayStore, link: googlePlayLink };
  } else {
    return { source: AppStore, link: appStoreLink }
  }
}

export const downloadButtons = [
  { source: AppStore, link: appStoreLink },
  {
    source: GooglePlayStore,
    link: googlePlayLink,
  },
];
export const getAdjustingFontSizeByHeightWidth = (width: number, height: number, textLength: number, maxFontSize: number = 24): number => {

  let fontSize = Math.sqrt(width * height / textLength)
  fontSize = Math.min(fontSize, maxFontSize)
  if (isNaN(fontSize)) {
    return maxFontSize
  }
  return fontSize;
}

const greenTileColour = "#ecf7eb"

export const ColourPalette = {

  primary: { light: "#6B8C07", main: "#314403", dark: "#1A2402" },
  accent: { light: "#F4AA78", main: "#FF9E10", dark: "#E4920E" },
  lightGrey: { light: "#F8F8F8", main: "#F2F2F2", dark: "#ECECEC" },
  darkGrey: { light: "#B0B0B0", main: "#808080", dark: "#5A5A5A" },
  yellow: { light: "#FFE699", main: "#FFD966", dark: "#D2A000" },
  brightGreen: { light: '#06f957', main: '#00A336', dark: "#002A0D" },
  blue: { light: '#E5E5FF', main: '#6161FF', dark: "#0000FF" },
  paleGrnBluRed: { light: "#E7FFE7", main: "#E5E5FF", dark: "#FFEBEB" },
  transparentBlack: { light: "undefined", main: 'rgba(0, 0, 0, 0.9)', dark: "undefined" },
  greyGreen: { light: "#C4C9C1", main: '#828C7C', dark: "#4D5549" },
  paleGreen: { light: "#F3FFF3", main: "#E7FFE7", dark: "#D1FFD1" },
  //paleBrightGreen: { light: "#a1f2a1", main: "#73eb73", dark: "#48e548" },
  paleRed: { light: "#FFF7F7", main: "#FFEBEB", dark: "#FFD5D5" },
  paleOrange: { light: "#fcf5e8", main: "#faebd2", dark: "undefined" },
  //paleBrightOrange: { light: "#efd49f", main: "#e8c174", dark: "#e1ae47" },
  red: { light: "#FFAFAF", main: "#FF9F9F", dark: "#FF2525" },
  whiteGreen: { light: "#e5f0e4", main: greenTileColour, dark: "#e0e8df" },
  pinkRed: { light: "#ffe8e8", main: "#ed8e8e", dark: "#d64242" },

  vibrantBlue: { light: "#2eceff", main: "#2eb6ff", dark: "#267dff" }, //old #568bfd
  vibrantPink: { light: "undefined", main: "#ff6e97", dark: "undefined" },
  vibrantPurple: { light: "#d06eff", main: "#b824ff", dark: "undefined" },
  vibrantOrange: { light: "undefined", main: "#ff7e2e", dark: "undefined" },
  vibrantGreenOrange: { light: "undefined", main: "#c1ff5e", dark: "undefined" },

  greenHeader: { light: '#06f957', main: '#00A336', dark: '#828C7C' },
  greenFooter: { light: '#86a583', main: '#88b582', dark: '#83a17f' },
  blueHeader: { light: '#0062a3', main: '#005ca3', dark: '#7c838c' },
  blueFooter: { light: '#839aa5', main: '#82a3b5', dark: '#7f9ca1' },
  tealHeader: { light: '#12c9c9', main: '#008080', dark: '#0b4242' },
  tealFooter: { light: '#95b8b8', main: '#728a8a', dark: '#3c4242' },
  brownHeader: { light: '#e69714', main: '#883501', dark: '#4f2911' },  //brownHeader: { light: '#6e4715', main: '#2e1c05', dark: '#1f1202' },
  brownFooter: { light: '#8a7667', main: '#7a6452', dark: '#3d3127' },  //brownFooter: { light: '#9e8b80', main: '#6e614c', dark: '#383023' },
  goldHeader: { light: "#F2BD21", main: "#AC7F00", dark: "#756b4c" },
  goldFooter: { light: "#b0a078", main: "#736541", dark: "#595447" },
  orangeHeader: { light: "#f27821", main: "#d64f15", dark: "#783100" },
  orangeFooter: { light: "#b08978", main: "#734f41", dark: "#594c47" },

  //redHeader: { light: '#a30008', main: '#2e0002', dark: '#170001' },
  //redFooter: { light: '#a38385', main: '#b88484', dark: '#9e7d7f' },
}

export function getScreenSize(): { width: number, height: number } {
  return screenSize;
}

export function getIsMobile(): boolean {
  return isMobile;
}

export function getIsTablet(): boolean {
  return isTablet;
}

export function setScreenSize(val: { width: number; height: number }) {
  screenSize = val;
  isMobile = screenSize.width <= 700 && screenSize.width < screenSize.height * 1.1; //TODO: should this be less than or equals to
  isTablet = !isMobile && screenSize.width <= 1400//1100; //992 on vamikas 1023 on catherines
}

export const sectionHeights = {
  navbarHeight: {
    mobile: 10,
    desktop: 10,
    margin: 0,
  },
  homeHeight: {
    mobile: 100,
    tablet: 140,
    desktop: 90,
    margin: 0,
  },
  feedbackEngineHeight: {
    mobile: 90,
    tablet: 140,
    desktop: 90,
    margin: 0,
  },
  duplicatePokerHeight: {
    mobile: 90,
    tablet: 140,
    desktop: 90,
    margin: 0,
  },
  statisticsHeight: {
    mobile: 90,
    tablet: 140,
    desktop: 90,
    margin: 0,
  },
  gotAQuestionHeight: {
    mobile: 90,
    tablet: 140,
    desktop: 90,
    margin: 0,
  },
  playWithFriendsHeight: {
    mobile: 80,
    tablet: 140,
    desktop: 90,
    margin: 0,
  },
  aboutHeight: {
    mobile: 80,
    desktop: 80,
    tablet: 60,
    margin: 5,
  },
  featuresCheckboxHeight: {
    mobile: 60,
    desktop: 60,
    margin: 5,
  },
  subscriptionsHeight: {
    mobile: 200,
    desktop: 75,
    margin: 0,
  },
  footerHeight: {
    mobile: 15,
    desktop: 10,
    margin: 0,
  },
  reviewsHeight: {
    mobile: 0,//75,
    desktop: 0,//75,
    margin: 0,
  },
};

export const phoneFrameDimensions: { [bigKey: string]: { [key: string]: string } } = {
  height: { mobile: "405.07px", desktop: "506.3375px", halfMobile: "202.535px" }, // mobile is iphone x
  width: { mobile: "200px", desktop: "250px", halfMobile: "100px" }
  // height: { mobile: "355.56px", desktop: "444.44px", halfMobile: "177.78px" },
  // width: { mobile: "200px", desktop: "250px", halfMobile: "100px" }
}

export const beginnerBannerText = "Shown: 'Starter' level analysis · Intermediate & Advanced also available · Interactive graph & concept 'explainers' available for newer players";
export function mainSectionHeight() {
  let sum = 0;
  for (const section in sectionHeights) {
    if (isMobile) {
      sum +=
        sectionHeights[section].mobile + 2 * sectionHeights[section].margin;
    } else {
      if ("tablet" in sectionHeights[section] && isTablet) {
        sum +=
          sectionHeights[section].tablet + 2 * sectionHeights[section].margin;
      } else {
        sum +=
          sectionHeights[section].desktop + 2 * sectionHeights[section].margin;
      }
    }
  }
  return sum.toString().concat("vh");
}

export function getMainSectionAfterHomeHeight() {
  let sum = 0;
  for (const section in sectionHeights) {
    if (section == "homeHeight") {
      continue;
    }
    if (isMobile) {
      sum +=
        sectionHeights[section].mobile + 2 * sectionHeights[section].margin;
    } else {
      if ("tablet" in sectionHeights[section] && isTablet) {
        sum +=
          sectionHeights[section].tablet + 2 * sectionHeights[section].margin;
      } else {
        sum +=
          sectionHeights[section].desktop + 2 * sectionHeights[section].margin;
      }
    }
  }
  console.log("height is " + sum);
  return sum.toString().concat("vh");
}

export function getSectionHeight(section: string): string {
  if (isMobile) {
    const height =
      sectionHeights[section].mobile + 2 * sectionHeights[section].margin;
    return height.toString().concat("vh");
  } else {
    if ("tablet" in sectionHeights[section] && isTablet) {
      const height =
        sectionHeights[section].tablet + 2 * sectionHeights[section].margin;
      return height.toString().concat("vh");
    } else {
      const height =
        sectionHeights[section].desktop + 2 * sectionHeights[section].margin;
      return height.toString().concat("vh");
    }
  }
}

export function getSectionMargin(section: string): string {
  if (isMobile) {
    const height = sectionHeights[section].margin;
    return height.toString().concat("vh");
  } else {
    const height = sectionHeights[section].margin;
    return height.toString().concat("vh");
  }
}

// interface AppStyles extends React.CSSProperties {}
// export type StylesDictionary = { [key: string]: AppStyles };
